const CreateInput = ({ className = "", placeholder, type = "text", onChange, value, min, max }) => {
  return (
    <input
      type={type}
      className={`
        ${className}
        w-full rounded-xl bg-slate-50 px-4 py-3
        outline-none transition
        focus:bg-white
        focus:ring-2 focus:ring-blue-50`}
      onChange={onChange}
      placeholder={placeholder}
      value={value ?? ""}
      min={min}
      max={max}
    />
  )
}

export default CreateInput
